import Vue from 'vue';
import VueRouter from 'vue-router';
import Home from '../views/Home.vue';

Vue.use(VueRouter);

// let defaultLangStr = navigator.language;
// let defaultPath = "/en/";

// if (defaultLangStr.indexOf("zh") >= 0) {
//   defaultPath = "/zh/";
// }

const routes = [
  {
    path: '/',
    name: 'Home',
    component: Home,
  },
  {
    path: '/donation',
    name: 'Donation',
    component: () =>
      import(/* webpackChunkName: "about" */ '../views/Donation.vue'),
  },
  {
    path: '/stake',
    name: 'Stake',
    component: () =>
      import(/* webpackChunkName: "about" */ '../views/Stake.vue'),
  },
  {
    path: '/fee',
    name: 'Fee',
    component: () =>
      import(/* webpackChunkName: "about" */ '../views/Fee.vue'),
  },
];

const router = new VueRouter({
  // mode: 'history',
  // base: process.env.BASE_URL,
  routes,
});

export default router;
